import { LegacyUrlRedirectRule } from 'app/models/url/url.model';

export const LEGACY_URL_REDIRECTS: ReadonlyArray<LegacyUrlRedirectRule> = [
  {
    oldUrl: 'signup.smartenance.festo.com',
    newUrl: 'smartenance.festo.com',
  },
  {
    oldUrl: 'test-reg-ecn.azurewebsites.net',
    newUrl: 'test-ecn.azurewebsites.net',
  },
];
